module.exports = __webpack_public_path__ + "img/coloredeer.d812261c.png";